import React from "react";
import { Link } from "react-router-dom";

import Layout from "../../components/Layout/Layout";

const positions = [
    {
        title: "Junior Legal Analyst",
        slug: "junior-legal-analyst",
        location: "Malta",
        posted: "2026-05-29",
        summary:
            "Support our legal and compliance teams across MiCA, the VFA Act, and cross-border payment operations.",
    },
    {
        title: "Operations & Finance Manager",
        slug: "ops-manager",
        location: "Malta",
        summary:
            "Drive corporate operations, finance, compliance, and HR across a high-growth FinTech.",
    },
    {
        title: "Project Manager",
        slug: "project-manager",
        location: "Malta",
        summary:
            "Coordinate multi-disciplinary teams, run agile delivery, and keep projects on track.",
    },
    {
        title: "Software Engineer, Solidity / Web3",
        slug: "solidity-engineer",
        location: "Malta",
        summary:
            "Build smart contracts and on-chain primitives for our DeFi and payments stack.",
    },
    {
        title: "QA Engineer",
        slug: "qa",
        location: "Malta",
        summary:
            "Own end-to-end test strategy across payments, custody, and crypto flows.",
    },
];

const formatPosted = (iso) => {
    if (!iso) return null;
    const d = new Date(`${iso}T00:00:00`);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
};

const Careers = () => {
    return (
        <Layout>
            <section className="page-hero">
                <div className="container">
                    <div className="eyebrow">
                        <span className="dot"></span> Careers
                    </div>
                    <h1>Join Everest</h1>
                    <p>
                        We&rsquo;re building global financial infrastructure for the
                        next generation of payments, custody, and identity. Browse
                        our open positions below, or reach out directly at{" "}
                        <a
                            href="mailto:careers@everest.org"
                            style={{ color: "var(--brand)" }}
                        >
                            careers@everest.org
                        </a>
                        .
                    </p>
                </div>
            </section>

            <section className="section section-tight">
                <div className="container">
                    <ul className="careers-list">
                        {positions.map((p) => {
                            const postedLabel = formatPosted(p.posted);
                            return (
                                <li key={p.slug}>
                                    <Link
                                        to={`/careers/${p.slug}`}
                                        className="careers-list-row"
                                    >
                                        <div className="careers-list-main">
                                            <h3>{p.title}</h3>
                                            <p>{p.summary}</p>
                                            {postedLabel && (
                                                <p className="careers-list-posted">
                                                    Posted{" "}
                                                    <time dateTime={p.posted}>
                                                        {postedLabel}
                                                    </time>
                                                </p>
                                            )}
                                        </div>
                                        <div className="careers-list-meta">
                                            {p.posted && (
                                                <span className="careers-list-new">
                                                    New
                                                </span>
                                            )}
                                            <span className="careers-list-tag">
                                                {p.location}
                                            </span>
                                            <span
                                                className="careers-list-arrow"
                                                aria-hidden="true"
                                            >
                                                &rarr;
                                            </span>
                                        </div>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>

                    <article
                        className="card"
                        style={{ marginTop: 24 }}
                    >
                        <span className="kicker">How to apply</span>
                        <h3>Send us your CV</h3>
                        <p>
                            Interested candidates should submit a cover letter,
                            CV, and any relevant work samples to{" "}
                            <a
                                href="mailto:careers@everest.org"
                                style={{ color: "var(--brand)" }}
                            >
                                careers@everest.org
                            </a>{" "}
                            with the subject line &ldquo;Everest Careers&rdquo;.
                        </p>
                    </article>
                </div>
            </section>
        </Layout>
    );
};

export default Careers;
